export const visit = (vm, at) => {
at({ "en": { "cardBizOpsCustomerSuccess": { "profileSidebarModule": { "bizOpsCustomerSuccessDataModule": { "header": "Success" } } } } });
};